<template>
    <PageLoading v-if="isLoading" />
    <div v-else class="main-wrap news-single-page">
        <div class="row">
            <div class="col-12 col-lg-12 row column">
                <div
                    class="news-header"
                    :style="{
                        'background-image': 'url(' + newsImage + ')',
                    }"
                >
                    <div class="overlay">
                        <div class="news-type row items-center"></div>
                        <h1>
                            {{ JSONParseTranslations(post.title, locale.key) }}
                        </h1>
                        <h6>{{ formatDate(post.start_date) }}</h6>
                    </div>
                </div>
                <div class="row justify-center">
                    <h3 class="col news-subtitle">
                        {{ JSONParseTranslations(post.subtitle, locale.key) }}
                    </h3>
                </div>
                <div class="news-content text-justify">
                    <span
                        v-html="JSONParseTranslations(post.content, locale.key)"
                    ></span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import translate from '@/local-shared/mixins/translate'
import PageLoading from '@/components/PageLoading'
import postsService from '@/services/modules/posts'
import picturesService from '@/services/pictures'
import formatDate from '@/helpers/date-time'
import encoders from '@/helpers/encoders'
import store from '@/store'

const loadingKeys = {
    fetchingPost: 'fetching-news',
    fetchingPicture: 'fetching-picture',
}

const publishedPostStatusId = 2

export default {
    name: 'PostDetails',

    components: {
        PageLoading,
    },

    mixins: [translate],

    data() {
        return {
            post: {},
            newsImage: '',
        }
    },

    computed: {
        locale() {
            return store.getters['locale/currentLocale']
        },

        isLoading() {
            return this.isFetchingPost
        },

        isFetchingPost() {
            return !!this.loadings.filter(
                (loading) => loading.key === loadingKeys.fetchingPost
            ).length
        },
    },

    async created() {
        await this.fetchPost()
    },

    methods: {
        dateMaskFormat() {
            return this.locale &&
                this.locale.definition &&
                this.locale.definition.dateFormat
                ? this.locale.definition.dateFormat
                : 'DD/MM/YYYY'
        },

        formatDate(value) {
            return value
                ? formatDate.fromServerToUxString(
                      value,
                      'date',
                      this.dateMaskFormat()
                  )
                : null
        },

        async fetchImage(pictureId) {
            let imageResponse = await picturesService.retrieveById(pictureId)

            if (imageResponse.status === 200) {
                return encoders.arrayBufferToBase64(imageResponse)
            } else {
                return '' //TODO: add a default image
            }
        },

        async fetchPost() {
            this.loadingAdd(loadingKeys.fetchingPost)

            let parameters = {
                filter: {
                    id: this.$route.params.postId,
                },
            }

            let response = await postsService.retrieve(parameters)

            if (response.status === 200) {
                this.post = response.data.results[0]

                if (
                    !this.post ||
                    this.post.post_status_id !== publishedPostStatusId ||
                    !this.post.active
                ) {
                    this.$router.push({ name: '404' })
                }

                if (this.post.picture_id) {
                    this.newsImage = await this.fetchImage(this.post.picture_id)
                } else {
                    this.newsImage = require('@/assets/logo.svg')
                }
            } else {
                this.$q.notify({
                    type: 'negative',
                    message: this.$t('notify.error_occurred', {
                        message: response.data.message,
                    }),
                })
            }

            this.loadingRemove(loadingKeys.fetchingPost)
        },
    },
}
</script>
